// extracted by mini-css-extract-plugin
module.exports =  {"root":"MTFIaBP49NRLWwuE3Y1o","icon":"ZpxxMuaw_moxtfPgGI9N","label":"uTSOfHcc6cuYd7Y9Wwy2","returnButton":"zw4hdRwz036fOS9Potep"};